'use client';

import React from 'react';
import HeroSection from './HeroSection';
import JourneyTimeline from './JourneyTimeline';
import PhilosophySection from './PhilosophySection';
import CertificationsCarousel from './CertificationsCarousel';
import MediaSection from './MediaSection';
import VideoIntroduction from './VideoIntroduction';
import CTASection from './CTASection';

interface GuideData {
  name: string;
  title: string;
  tagline: string;
  image: string;
  alt: string;
  yearsOfPractice: number;
  clientsGuided: number;
  certificationsCount: number;
}

interface TimelineEvent {
  year: string;
  title: string;
  description: string;
  icon: string;
}

interface PhilosophyPillar {
  icon: string;
  title: string;
  description: string;
}

interface Philosophy {
  statement: string;
  pillars: PhilosophyPillar[];
}

interface Certification {
  id: number;
  name: string;
  organization: string;
  year: string;
  image: string;
  alt: string;
}

interface MediaFeature {
  id: number;
  publication: string;
  title: string;
  date: string;
  image: string;
  alt: string;
  link: string;
}

interface VideoData {
  title: string;
  description: string;
  thumbnailUrl: string;
  videoUrl: string;
}

interface AboutInteractiveProps {
  guideData: GuideData;
  timelineEvents: TimelineEvent[];
  philosophy: Philosophy;
  certifications: Certification[];
  mediaFeatures: MediaFeature[];
  videoData: VideoData;
}

const AboutInteractive: React.FC<AboutInteractiveProps> = ({
  guideData,
  timelineEvents,
  philosophy,
  certifications,
  mediaFeatures,
  videoData,
}) => {
  return (
    <>
      <HeroSection data-component-id="src/app/about/components/AboutInteractive.tsx:86:6" data-component-path="src/app/about/components/AboutInteractive.tsx" data-component-line="86" data-component-end-line="86" data-component-file="AboutInteractive.tsx" data-component-name="HeroSection" data-component-content="%7B%22elementName%22%3A%22HeroSection%22%7D" guide={guideData} />
      <JourneyTimeline data-component-id="src/app/about/components/AboutInteractive.tsx:87:6" data-component-path="src/app/about/components/AboutInteractive.tsx" data-component-line="87" data-component-end-line="87" data-component-file="AboutInteractive.tsx" data-component-name="JourneyTimeline" data-component-content="%7B%22elementName%22%3A%22JourneyTimeline%22%7D" events={timelineEvents} />
      <PhilosophySection data-component-id="src/app/about/components/AboutInteractive.tsx:88:6" data-component-path="src/app/about/components/AboutInteractive.tsx" data-component-line="88" data-component-end-line="88" data-component-file="AboutInteractive.tsx" data-component-name="PhilosophySection" data-component-content="%7B%22elementName%22%3A%22PhilosophySection%22%7D" philosophy={philosophy} />
      <VideoIntroduction data-component-id="src/app/about/components/AboutInteractive.tsx:89:6" data-component-path="src/app/about/components/AboutInteractive.tsx" data-component-line="89" data-component-end-line="89" data-component-file="AboutInteractive.tsx" data-component-name="VideoIntroduction" data-component-content="%7B%22elementName%22%3A%22VideoIntroduction%22%7D" videoData={videoData} />
      <CertificationsCarousel data-component-id="src/app/about/components/AboutInteractive.tsx:90:6" data-component-path="src/app/about/components/AboutInteractive.tsx" data-component-line="90" data-component-end-line="90" data-component-file="AboutInteractive.tsx" data-component-name="CertificationsCarousel" data-component-content="%7B%22elementName%22%3A%22CertificationsCarousel%22%7D" certifications={certifications} />
      <MediaSection data-component-id="src/app/about/components/AboutInteractive.tsx:91:6" data-component-path="src/app/about/components/AboutInteractive.tsx" data-component-line="91" data-component-end-line="91" data-component-file="AboutInteractive.tsx" data-component-name="MediaSection" data-component-content="%7B%22elementName%22%3A%22MediaSection%22%7D" features={mediaFeatures} />
      <CTASection data-component-id="src/app/about/components/AboutInteractive.tsx:92:6" data-component-path="src/app/about/components/AboutInteractive.tsx" data-component-line="92" data-component-end-line="92" data-component-file="AboutInteractive.tsx" data-component-name="CTASection" data-component-content="%7B%22elementName%22%3A%22CTASection%22%7D" />
    </>
  );
};

export default AboutInteractive;